import { EstadoLoteBadge } from "@/components/migracion/EstadoLoteBadge";
import { fechaCorta } from "@/lib/migracion";

export function HistorialLotes({ lotes, activo, onVer }) {
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5" data-testid="migracion-historial">
      <h2 className="text-base font-semibold text-slate-900">Historial de migraciones</h2>
      {lotes.length === 0 ? (
        <p className="mt-2 text-sm text-slate-400" data-testid="migracion-historial-vacio">Aún no hay migraciones.</p>
      ) : (
        <div className="mt-3 overflow-x-auto">
          <table className="w-full min-w-[720px] text-sm">
            <thead className="text-left text-[11px] uppercase tracking-wide text-slate-500">
              <tr>
                <th className="py-2 pr-3">Fecha</th><th className="py-2 pr-3">Archivo</th><th className="py-2 pr-3">Quién</th>
                <th className="py-2 pr-3">Estado</th><th className="py-2 pr-3 text-right">Clientes: nuevos / vinculados / errores</th>
                <th className="py-2 pr-3 text-right">Créditos: válidos / errores</th>
                <th className="py-2 pr-3 text-right">Correcciones: válidas / errores</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {lotes.map((l) => { const c = l.conteos || {}; return (
                <tr key={l.id} onClick={() => onVer(l.id)} data-testid={`migracion-historial-${l.id}`}
                  className={`cursor-pointer transition-colors hover:bg-slate-50 ${activo === l.id ? "bg-slate-50" : ""}`}>
                  <td className="py-2 pr-3 text-slate-600">{fechaCorta(l.created_at)}</td>
                  <td className="py-2 pr-3 text-slate-800">{l.nombre_archivo}<span className="ml-1 font-mono text-[11px] text-slate-400">{l.id}</span></td>
                  <td className="py-2 pr-3 text-slate-600">{l.creado_por}</td>
                  <td className="py-2 pr-3"><EstadoLoteBadge estado={l.estado} /></td>
                  <td className="py-2 pr-3 text-right font-mono tabular-nums text-slate-700">
                    {l.filas_nuevas} / {l.filas_vinculadas} / {(l.filas_error || 0) + (c.errores_proceso || 0)}
                  </td>
                  <td className="py-2 pr-3 text-right font-mono tabular-nums text-slate-700" data-testid={`migracion-historial-creditos-${l.id}`}>
                    {l.creditos?.total ? `${l.creditos.validos} / ${c.creditos_error ?? l.creditos.error}` : "—"}
                  </td>
                  <td className="py-2 pr-3 text-right font-mono tabular-nums text-slate-700" data-testid={`migracion-historial-correcciones-${l.id}`}>
                    {l.correcciones?.total ? `${l.correcciones.validos} / ${c.correcciones_error ?? l.correcciones.error}` : "—"}
                  </td>
                </tr>
              ); })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
